import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { openPanel } from '../../../../reducer/panel-slider';
import { BOOKING_COMPONENT } from '../../../../constants/panel-slider-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHospital } from '@fortawesome/free-solid-svg-icons';
import {
  faBell,
  faUserCircle,
  faLifeRing,
} from '@fortawesome/free-regular-svg-icons';
import ProfilePopUp from './profilePopUp';
import SupportModal from './supportModal';
import classes from './style.module.scss';
import { Button } from '../../../ui';
import { useState } from 'react';

const Header = () => {
  const dispatch = useDispatch();

  // * Required states * //
  const [userPopUpStatus, setUserPopUpStatus] = useState(false);
  const [supportModalOpen, setSupportModalOpen] = useState(false);

  // * Getting data from redux store * //
  const { clinic_name } = useSelector(
    (state: RootState) => state.authentication.user
  );

  // * Function to handle blur on the div * //
  const handleBlure = () => {
    setTimeout(() => {
      setUserPopUpStatus(false);
    }, 200);
  };

  return (
    <header className={classes.header}>
      <span className={classes.heading}>
        <FontAwesomeIcon icon={faHospital} />
        {clinic_name}
      </span>

      <div className={classes.navigation}>
        <Button
          label="Book Appointment"
          onClick={() => {
            dispatch(openPanel(BOOKING_COMPONENT));
          }}
          style={{
            borderRadius: '6px',
            fontSize: '1rem',
            textTransform: 'capitalize',
          }}
        />
      </div>

      <div className={classes.quickactions}>
        <span
          className={classes.support}
          title="Support"
          onClick={() => setSupportModalOpen(true)}
        >
          <FontAwesomeIcon icon={faLifeRing} />
          Support
        </span>
        <SupportModal open={supportModalOpen} onClose={() => setSupportModalOpen(false)} />
        <span className={classes.item}>
          <FontAwesomeIcon icon={faBell} />
        </span>
        <div
          className={classes.item}
          onFocus={() => setUserPopUpStatus(true)}
          onBlur={handleBlure}
          tabIndex={0}
        >
          <FontAwesomeIcon icon={faUserCircle} />
        </div>
      </div>
      {userPopUpStatus && (
        <ProfilePopUp setUserPopUpStatus={setUserPopUpStatus} />
      )}
    </header>
  );
};
export default Header;
